import type { ConsentExtendPayload, ExtendUnit } from './api';

export const UNIT_OPTIONS: { label: string; value: ExtendUnit }[] = [
  { label: 'Days', value: 'days' },
  { label: 'Weeks', value: 'weeks' },
  { label: 'Months', value: 'months' },
  { label: 'Years', value: 'years' },
];

// The `extend` action takes a duration XOR a never-expiring grant.
export const buildExtendPayload = (
  value: number,
  unit: ExtendUnit,
  noExpiry: boolean
): ConsentExtendPayload => (noExpiry ? { no_expiry: true } : { value, unit });
